import { useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import { currentVisit, error } from '../store/state';
import { ensureVisitLoaded, marcarFallida } from '../store/actions/visit.actions';
import { Shell } from '../layout/Shell';

interface Props {
  id: string;
}

export function FallidaFormView({ id }: Props) {
  useEffect(() => {
    ensureVisitLoaded(id);
  }, [id]);

  const v = currentVisit.value;
  if (!v) return <Shell tab="agenda">{null}</Shell>;

  const onSubmit = async (e: Event) => {
    e.preventDefault();
    const fd = new FormData(e.currentTarget as HTMLFormElement);
    try {
      await marcarFallida(v.id, String(fd.get('motivo')));
    } catch (err) {
      error.value = (err as Error).message;
    }
  };

  return (
    <Shell tab="agenda">
      <h2>Visita no realizada</h2>
      <div class="card">
        <strong>{v.client?.nombre}</strong>
      </div>
      <form class="form-desktop" onSubmit={onSubmit}>
        <label>¿Por qué no se pudo hacer la visita?</label>
        <textarea name="motivo" required placeholder="Ej: No había nadie, edificio cerrado, acceso denegado" />
        <button class="danger-outline" type="submit">
          Confirmar como fallida
        </button>
        <button class="secondary" type="button" onClick={() => route(`/visitas/${v.id}`)}>
          Cancelar
        </button>
      </form>
      <p class="muted" style={{ marginTop: 8 }}>
        Se va a crear una visita de reemplazo automáticamente.
      </p>
    </Shell>
  );
}
